import _defineProperty from "/var/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/var/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/var/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es.array.sort.js";
import * as React from "react";
import { devicePixelRatio, IMAGE_FIT_CONTAIN, IMAGE_FIT_COVER, ImageSlide, useEventCallback, useLayoutEffect } from "../../core/index.js";
export var isResponsiveImageSlide = function isResponsiveImageSlide(slide) {
  var _a;

  return (((_a = slide.srcSet) === null || _a === void 0 ? void 0 : _a.length) || 0) > 0;
};
export var ResponsiveImage = function ResponsiveImage(props) {
  var _a, _b;

  var _React$useState = React.useState({}),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      state = _React$useState2[0],
      setState = _React$useState2[1];

  var current = state.current,
      preload = state.preload;
  var image = props.slide,
      rect = props.rect,
      imageFit = props.imageFit,
      render = props.render;
  var srcSet = image.srcSet.sort(function (a, b) {
    return a.width - b.width;
  });
  var width = (_a = image.width) !== null && _a !== void 0 ? _a : srcSet[srcSet.length - 1].width;
  var height = (_b = image.height) !== null && _b !== void 0 ? _b : srcSet[srcSet.length - 1].height;
  var cover = image.imageFit === IMAGE_FIT_COVER || image.imageFit !== IMAGE_FIT_CONTAIN && imageFit === IMAGE_FIT_COVER;
  var maxWidth = Math.max.apply(Math, _toConsumableArray(srcSet.map(function (x) {
    return x.width;
  })));
  var targetWidth = Math.min((cover ? Math.max : Math.min)(rect.width, width * (rect.height / height)), maxWidth);
  var pixelDensity = devicePixelRatio();
  var handleSourceChange = useEventCallback(function () {
    var _a;

    var targetSource = (_a = srcSet.find(function (x) {
      return x.width >= targetWidth * pixelDensity;
    })) !== null && _a !== void 0 ? _a : srcSet[srcSet.length - 1];

    if (!current) {
      setState(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          current: targetSource.src
        });
      });
    } else if (srcSet.findIndex(function (x) {
      return x.src === current;
    }) < srcSet.findIndex(function (x) {
      return x === targetSource;
    })) {
      setState(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          preload: targetSource.src
        });
      });
    }
  });
  useLayoutEffect(handleSourceChange, [rect === null || rect === void 0 ? void 0 : rect.width, rect === null || rect === void 0 ? void 0 : rect.height, pixelDensity, image.src, handleSourceChange]);
  var handlePreload = useEventCallback(function (currentPreload) {
    if (currentPreload === preload) {
      setState(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          current: preload,
          preload: undefined
        });
      });
    }
  });

  var style = _objectSpread({
    WebkitTransform: "translateZ(0)"
  }, rect.width / rect.height < width / height ? {
    width: "100%",
    height: "auto"
  } : {
    width: "auto",
    height: "100%"
  });

  return React.createElement(React.Fragment, null, preload && preload !== current && React.createElement(ImageSlide, _objectSpread(_objectSpread({
    key: "preload"
  }, props), {}, {
    slide: _objectSpread(_objectSpread({}, image), {}, {
      src: preload,
      srcSet: undefined
    }),
    style: _objectSpread({
      position: "absolute",
      visibility: "hidden"
    }, style),
    onLoad: function onLoad() {
      return handlePreload(preload);
    },
    render: _objectSpread(_objectSpread({}, render), {}, {
      iconLoading: function iconLoading() {
        return null;
      },
      iconError: function iconError() {
        return null;
      }
    })
  })), current && React.createElement(ImageSlide, _objectSpread(_objectSpread({
    key: "current"
  }, props), {}, {
    slide: _objectSpread(_objectSpread({}, image), {}, {
      src: current,
      srcSet: undefined
    }),
    style: style
  })));
};